module.exports = __webpack_public_path__ + "img/40h60.33a1c915.svg";